import tacklebox from "tacklebox";

import { Page } from '@/js/Page.js';

import { History } from "../dto/History";

function Answer(id, title, description, unit = null) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.unit = unit;
}


function Qa(raw) {
    this.raw = raw;
}
Qa.prototype.getQuestionId = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.id;
    }
    return "";
};
Qa.prototype.getQuestionTitle = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.title;
    }
    return "";
};
Qa.prototype.getQuestionAllNumber = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.allstep;
    }
    return "";
};
Qa.prototype.getQuestionNumber = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.step;
    }
    return "";
};
Qa.prototype.getQuestionDescription = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.description;
    }
    return "";
};
Qa.prototype.getAnswers = function () {
    if (this.raw?.qa?.answers) {
        let anws = [];
        for (let i in this.raw?.qa?.answers) {
            let ans = this.raw?.qa?.answers[i];
            let unit = null;
            if (ans?.unit) {
                unit = ans?.unit;
            }
            anws.push(new Answer(
                ans.id,
                ans.title,
                ans.description,
                unit
            ));
        }
        return anws;
    }

    return [];
};
Qa.prototype.isMultiSelect = function () {
    if (this.raw?.qa?.form) {
        if (this.raw.qa.form == "multi") {
            return true;
        }
    }
    return false;
};
Qa.prototype.getHistory = function () {
    let hs = [];

    for (let i in this.raw?.histories) {
        hs.push(
            new History(
                this.raw?.histories[i]
            )
        );
    }

    return hs;
};
Qa.prototype.getPhase = function () {
    if (this.raw?.phase) {
        try {
            return this.raw.phase;
        } catch (ex) {
            tacklebox.e(ex);
        }
    }
    return "";
};

Qa.prototype.getExpectationTitle = function () {
    if (this.raw?.qa?.expectaion_title) {
        try {
            return this.raw.qa.expectaion_title;
        } catch (ex) {
            tacklebox.e(ex);
        }
    }
    return "";
};


function InterviewPage(callback = () => { }) {
    Page.call(this, "interview", "質疑応答");
    this.interviewId = "";
    this.qa = null;
    this.isProgress = false;
    this.callback = callback;
    this.selecteds = [];
    this.qaLoading = true;
}
tacklebox.design.extend(InterviewPage, Page);
InterviewPage.prototype.isSelected = function () {
    return this.selecteds.length > 0;
};
InterviewPage.prototype.select = function (question_id) {
    if (this.qa) {
        if (!this.qa.isMultiSelect()) {
            if (this.selecteds.length > 0) {
                if (this.selecteds[0] == question_id) {
                    this.selecteds = [];
                    return;
                }
            }
            this.selecteds = [question_id];
            return;
        }
    }
    for (let i = 0; i < this.selecteds.length; i++) {
        let sid = this.selecteds[i];
        if (sid == question_id) {
            this.selecteds.splice(i, 1);
            return;
        }
    }
    this.selecteds.push(question_id);
};
InterviewPage.prototype._onInitialize = function () {
    this.loadQa();
};
InterviewPage.prototype.loadQa = function () {
    const self = this;
    this.qa = null;
    this.selecteds = [];
    this.isProgress = true;
    self.qaLoading = true;
    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/ask", {
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then((response) => response.json())
        .then((json) => {
            self.qa = new Qa(json.data);
            if (json.data.qa == null) {
                if (self.callback) {
                    self.callback();
                }
            }
            self.isProgress = false;
            self.qaLoading = false;
        })
        .catch((error) => {
            tacklebox.e(error)
            self.isProgress = false;
            self.qaLoading = false;
        });
};
InterviewPage.prototype.skip = function () {
    this.selecteds = [];
    this.reply(true);
};
InterviewPage.prototype.reply = function (isForce = false) {
    if (!isForce) {
        if (!this.isSelected()) {
            return;
        }
    }
    let rbody = {
        "id": this.qa.getQuestionId(),
        "question_id": this.qa.getQuestionId(),
        "answers": this.selecteds
    };
    const self = this;
    self.qaLoading = true;
    window.scrollTo(0, 0);  //TBD
    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/reply", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(rbody)
    })
        .then((response) => response.json())
        .then((json) => {
            if (json) {
                //
            }
            self.loadQa();
        })
        .catch((error) => {
            tacklebox.e(error);
            self.qaLoading = false;
        });
};
InterviewPage.prototype.amountreply = function (amount) {
    if (amount < 1) {
        return;
    }
    let rbody = {
        "id": this.qa.getQuestionId(),
        "question_id": this.qa.getQuestionId(),
        "answers": [this.qa.getQuestionId()],
        "input_text": amount
    };
    const self = this;
    window.scrollTo(0, 0);  //TBD
    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/reply", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(rbody)
    })
        .then((response) => response.json())
        .then((json) => {
            if (json) {
                //
            }
            self.loadQa();
        })
        .catch((error) => {
            tacklebox.e(error)
        });
};


InterviewPage.prototype.cencel = function () {
    const self = this;
    if (this.qa) {
        let hs = this.qa.getHistory();
        if (hs.length > 1) {
            let trg = hs[hs.length - 1];
            // /interviews/{id}/history/{history_id}
            // self.loadQa();
            if (trg.getPhase() == 'question' || trg.getPhase() == 'questionnaire') {
                fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/history/" + trg.getId(), {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    // body: JSON.stringify(rbody)
                })
                    .then((response) => response.json())
                    .then((json) => {
                        if (json) {
                            //
                        }
                        self.loadQa();
                    })
                    .catch((error) => {
                        tacklebox.e(error)
                    });
            }
            if (trg.getPhase() == 'entry') {
                fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/history/" + trg.getId(), {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    // body: JSON.stringify(rbody)
                })
                    .then((response) => response.json())
                    .then((json) => {
                        if (json) {
                            //
                        }
                        ////////////////////////////

                        let rbody = {
                            "session": "x"
                        };

                        fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/reentry", {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(rbody)
                        })
                            .then((response) => response.json())
                            .then((json) => {
                                if (json?.data) {
                                    ///////
                                    self.onReEntryCallback();
                                }
                            })
                            .catch((error) => {
                                tacklebox.e(error)
                            });

                    })
                    .catch((error) => {
                        tacklebox.e(error)
                    });
            }


        } else {
            let rbody = {
                "session": "x"
            };

            fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/reentry", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(rbody)
            })
                .then((response) => response.json())
                .then((json) => {
                    if (json?.data) {
                        self.onReEntryCallback();
                    }
                })
                .catch((error) => {
                    tacklebox.e(error)
                });
        }
    }
};

InterviewPage.prototype.onReEntryCallback = function () { };
InterviewPage.prototype.getPhase = function () {
    if (this.qa) {
        return this.qa.getPhase();
    }
    return "";
};



export { InterviewPage }
